import React from 'react';
import PropTypes from 'prop-types';

import { Field, connect } from 'formik';
import { map } from 'lodash-es';

import Input from '../../../CommonV2/Input';

import { TypesFieldEnum } from './enum';

/**
 * FieldInput
 * @param {*} param0
 */
const FieldInput = ({ code, type, disabled, digits, validate, existError, showError, handleBlur, placeholder }) => (
  <Field
    component={Input}
    name={code}
    type={type}
    disabled={disabled}
    digits={digits}
    validate={validate}
    existError={existError}
    showError={showError}
    eventEmitter={v => handleBlur(v)}
    placeholder={placeholder}
  />
);

FieldInput.propTypes = {
  code: PropTypes.string.isRequired,
  type: PropTypes.oneOf(map(TypesFieldEnum, item => item)).isRequired,
  disabled: PropTypes.bool,
  digits: PropTypes.number,
  validate: PropTypes.func.isRequired,
  handleBlur: PropTypes.func.isRequired,
  existError: PropTypes.bool.isRequired,
  showError: PropTypes.bool.isRequired,
  placeholder: PropTypes.string,
};
FieldInput.defaultProps = {
  digits: undefined,
  disabled: false,
  placeholder: undefined,
};

export default connect(FieldInput);
